import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { SITE } from "../lib/site";

export const FloatingCall = () => (
    <motion.a
        data-testid="phone-call-floating-button"
        href={SITE.phoneHref}
        aria-label={`Call ${SITE.phoneDisplay}`}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
        className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-white text-black shadow-[0_8px_40px_rgba(255,255,255,0.25)]"
    >
        <Phone className="w-5 h-5" />
    </motion.a>
);
